import { FormProvider, useForm, UseFormMethods } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FieldName } from "react-hook-form/dist/types/fields";
import Yup from "yup";

import { IChildrenAsFunction } from "types/IChildrenAsFunction";
import { IErrorField } from "./types/IErrorField";

interface IProps<T> {
  onSubmit: (
    model: T,
    setCustomErrors: (errors: IErrorField[]) => void
  ) => void;
  children: IChildrenAsFunction<UseFormMethods<T>>;
  defaultValues: any;
  validationSchema?: Yup.AnyObjectSchema;
  resetOnSubmit?: boolean;
}

const Form = <T extends {}>({
  onSubmit,
  validationSchema,
  defaultValues,
  children,
  resetOnSubmit = true,
}: IProps<T>) => {
  const methods = useForm<T>({
    ...(validationSchema && { resolver: yupResolver(validationSchema) }),
    mode: "all",
    defaultValues: defaultValues,
  });

  //Aby poprawnie działało form musi otrzymać dodatkowo resetOnSubmit={false}
  const setCustomErrors = (errors: IErrorField[]) => {
    errors?.forEach((error) => {
      methods.setError(error.name as FieldName<T>, {
        message: error.error,
        type: "manual",
      });
    });
  };

  const handleSubmit = async (model: T) => {
    await onSubmit(model, setCustomErrors);
    resetOnSubmit && methods.reset();
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        {children(methods)}
      </form>
    </FormProvider>
  );
};

export { Form };
